export default __webpack_public_path__ + "static/inside-bg-5-28a9ba30300b2fa15af68920cf1452cd.jpg";